import { render, staticRenderFns } from "./EditAoaiKeyVault.vue?vue&type=template&id=119b7650&scoped=true&"
import script from "./EditAoaiKeyVault.vue?vue&type=script&lang=js&"
export * from "./EditAoaiKeyVault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119b7650",
  null
  
)

export default component.exports